import { SECTION_LIST_HEADING } from '../actions/types'

const initialState = {}

const sectionIndexReducer = (state = initialState, action) => {
  switch (action.type) {
    case SECTION_LIST_HEADING:
      return { ...action.payload }
    default:
      return state
  }
}

export default sectionIndexReducer
